import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Tenant {
  tenantId: string;
  email: string;
  createdAt: string;
}

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  tenant: Tenant | null;
  isAuthenticated: boolean;
  setAuth: (accessToken: string, refreshToken: string, tenant: Tenant) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      tenant: null,
      isAuthenticated: false,
      setAuth: (accessToken, refreshToken, tenant) =>
        set({ accessToken, refreshToken, tenant, isAuthenticated: true }),
      logout: () =>
        set({ accessToken: null, refreshToken: null, tenant: null, isAuthenticated: false }),
    }),
    {
      name: 'project-brain-auth',
    }
  )
);

// Selected state
interface UIState {
  selectedProjectId: string | null;
  selectedAspectId: string | null;
  setSelectedProject: (id: string | null) => void;
  setSelectedAspect: (id: string | null) => void;
}

export const useUIStore = create<UIState>((set) => ({
  selectedProjectId: null,
  selectedAspectId: null,
  setSelectedProject: (id) => set({ selectedProjectId: id }),
  setSelectedAspect: (id) => set({ selectedAspectId: id }),
}));

